module.exports = __webpack_public_path__ + "img/1.f3ebaa57.jpg";